module.exports = {"150627100":"阿勒腾席热镇","150627101":"札萨克镇","150627102":"乌兰木伦镇","150627103":"纳林陶亥镇","150627104":"苏布尔嘎镇","150627105":"红庆河镇","150627106":"伊金霍洛镇","150627400":"鄂尔多斯江苏工业园区","150627403":"鄂尔多斯圣圆煤化工基地","150627405":"鄂尔多斯蒙古源流文化产业园区","150627406":"伊金霍洛旗札萨克物流园区","150627407":"鄂尔多斯空港物流园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150627.json
// module id = 444
// module chunks = 0